/**
 * @typedef {Object} ConstructionLog
 * @property {string} project_name
 * @property {string} group_of_works
 * @property {boolean} always_add_second_page
 * @property {LogPage[]} log_pages
 */

/**
 * @typedef {Object} LogPage
 * @property {string[]} attached_file_paths
 * @property {string} contractor_legal_entity_name
 * @property {string} investor_legal_entity_name
 * @property {string} investor_legal_entity_address
 * @property {string} place
 * @property {string} contractor_sign
 * @property {string} date
 * @property {string} day
 * @property {string} ncontractor_sign
 * @property {number} number
 * @property {string} remarks
 * @property {Shift[]} shifts
 * @property {string} supervisor_sign
 * @property {Temperature[]} temperatures
 * @property {string} water_level
 * @property {string} weather
 * @property {string} wind_speed
 * @property {string} work_description
 */

/**
 * @typedef {Object} Shift
 * @property {number} construction_workers
 * @property {number} craft_workers
 * @property {string} end_time
 * @property {number} i
 * @property {string} mechanization
 * @property {number} nEmployeeTotal
 * @property {number} others
 * @property {string} start_time
 * @property {number} technical_staff
 * @property {number} total_time
 */

/**
 * @typedef {Object} Temperature
 * @property {number} i
 * @property {string} temperatureTime
 * @property {string} temperatureValue
 */

/**
 * Sorts log pages, shifts and temperatures of json
 * @param {ConstructionLog} json 
 */
export const sortConstructionLogJson = json => {
  json.log_pages.sort((a, b) => a.number - b.number)
  json.log_pages.forEach(page => {
    page.shifts.sort((a, b) => a.i - b.i)
    page.temperatures.sort((a, b) => a.i - b.i)
  })
}